import { MorningAuthConnectRequestSchema } from "@vy/api-definition";
import type { oz } from "@vy/utils";
import type { Control } from "react-hook-form";

export const MorningRegisterFormSchema = MorningAuthConnectRequestSchema;

export type MorningRegisterFormValues = oz.infer<typeof MorningRegisterFormSchema>;
export type MorningRegisterFormControl = Control<MorningRegisterFormValues>;